import { useEffect, FunctionComponent, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { isNil } from 'lodash';
import { Divider } from '@material-ui/core';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  DrawerDiv,
  DrawerContainer,
} from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer/style';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import TimeLineContent from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer/TimlineContent';
export interface TrackingActionDrawerProps {
  intl: IntlShape;
  isDrawerOpen: boolean;
  setIsDrawerOpen: Function;
  userActions: any;
  listings: any;
  claimHistorySagis: any;
  claimNumber: string;
  requestGetClaimHistoryActions: any;
  requestGetClaimHistorySagis: any;
  claimId: number;
  loaders: any;
}
const TrackingActionDrawer: FunctionComponent<TrackingActionDrawerProps> = ({
  ...props
}): JSX.Element => {
  const [tab, setTab] = useState(0);
  useEffect(() => {
    if (
      featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) &&
      !isNil(props.claimNumber) &&
      props.claimId
    ) {
      props.requestGetClaimHistoryActions(props.claimId);
      props.requestGetClaimHistorySagis(props.claimNumber);
    }
  }, [props.isDrawerOpen]);
  /* istanbul ignore next */
  const handleToggleDrawer = () => {
    props.setIsDrawerOpen(!props.isDrawerOpen);
  };

  return (
    <DrawerContainer
      anchor="right"
      open={props.isDrawerOpen}
      onClose={handleToggleDrawer}
    >
      <DrawerDiv>
        <div className="titleConatainer">
          <span className="title">
            {translate({ ...messages.trackingDrawerTitle }, props)}
          </span>
        </div>
        <Divider className="divider" />
        <TimeLineContent
          listings={props.listings}
          loaders={props.loaders}
          claimHistorySagis={props.claimHistorySagis}
          setTab={setTab}
          userActions={props.userActions?.filter(
            (item: any) => !item.technicalAction,
          )}
          tab={tab}
        />
      </DrawerDiv>
    </DrawerContainer>
  );
};

export default injectIntl(TrackingActionDrawer);
